module.exports = __webpack_public_path__ + "static/media/vishal.9e435e3c.jpg";